import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import styled from 'styled-components';
import { Colors, StyledComponents } from '../../themes';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import EmailWrap from '../common/EmailWrap';

const { ContentGroup, ContentLabel, ContentLine, ContentLineGroup } = StyledComponents;

const OrangeUnderline = styled.div`
  height: 50px;
  position: relative;
  &:after {
    content: '';
    width: 60px;
    height: 4px;
    background: ${Colors.orange};
    position: absolute;
    bottom: 0;
    left: 0;
  },
`;

const styles = (theme) => ({
  distributorWidgetContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowWrap: 'break-word',
  },
  headerContainer: {
    background: Colors.hoverGrey,
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: '4px 4px 0 0',
  },
  label: {
    margin: 0,
  },
  distributorImageAndNameRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 8,
  },
  companyName: {
    margin: 0,
  },
  emptyCircle: {
    marginRight: 16,
  },
  bodyContainer: {
    background: Colors.navBackgroundGrey,
    minHeight: 200,
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    borderRadius: '0 0 4px 4px',
  },
  contentColumn: {
    height: '100%',
    textAlign: 'left',
    padding: '0 16px 0 16px',
  },
  firstColumn: {
    paddingTop: 16,
    paddingBottom: 16,
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 0,
    },
  },
  secondColumn: {
    paddingTop: 16,
    paddingBottom: 16,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
    },
  },
});

class DistributorInfos extends Component {
  render() {
    const { t, classes, distributorInfo } = this.props;
    let distributorName = t('distributor');
    let street1 = '',
      street2 = '',
      street1no = '',
      street2no = '',
      zip = '',
      city = '',
      phone = '',
      email = '',
      contactPersonName = '',
      contactPersonPhone = '',
      contactPersonEmail = '';

    if (distributorInfo) {
      distributorName =
        distributorInfo.distributorName || distributorInfo.address.fullName || distributorInfo.address.firstName || '';
      if (distributorInfo.address) {
        const { address } = distributorInfo;
        street1 = address.street1;
        street2 = address.street2;
        street1no = address.street1no;
        street2no = address.street2no;
        zip = address.zip;
        city = address.city;
      }
      if (distributorInfo.distributorSetting && distributorInfo.distributorSetting.length > 0) {
        const { distributorSetting } = distributorInfo;

        const emailSetting = distributorSetting.find(
          (setting) => setting.distributorSettingTypeId.name === 'TYPE_COMPANY_CONTACT_EMAIL'
        );
        if (emailSetting && emailSetting.distributorSettingValue) {
          email = emailSetting.distributorSettingValue;
        }

        const phoneSetting =
          distributorSetting.find(
            (setting) => setting.distributorSettingTypeId.name === 'TYPE_COMPANY_CONTACT_PHONE'
          ) || distributorSetting.find((setting) => setting.distributorSettingTypeId.name === 'TYPE_WIDGET_EXTRA_TEXT');
        if (phoneSetting && phoneSetting.distributorSettingValue) {
          phone = phoneSetting.distributorSettingValue;
        }

        const contactPersonNameSetting = distributorSetting.find(
          (setting) => setting.distributorSettingTypeId.name === 'TYPE_CONTACT_PERSON_NAME'
        );
        if (contactPersonNameSetting && contactPersonNameSetting.distributorSettingValue) {
          contactPersonName = contactPersonNameSetting.distributorSettingValue;
        }

        const contactPersonEmailSetting = distributorSetting.find(
          (setting) => setting.distributorSettingTypeId.name === 'TYPE_CONTACT_PERSON_EMAIL'
        );
        if (contactPersonEmailSetting && contactPersonEmailSetting.distributorSettingValue) {
          contactPersonEmail = contactPersonEmailSetting.distributorSettingValue;
        }

        const contactPersonPhoneSetting = distributorSetting.find(
          (setting) => setting.distributorSettingTypeId.name === 'TYPE_CONTACT_PERSON_PHONE'
        );
        if (contactPersonPhoneSetting && contactPersonPhoneSetting.distributorSettingValue) {
          contactPersonPhone = contactPersonPhoneSetting.distributorSettingValue;
        }
      }
    }

    return (
      <Grid container className={classes.distributorWidgetContainer}>
        <Grid item xs={12}>
          <div className={classes.headerContainer}>
            <Typography variant="h2" className={classes.label}>
              {t('distributor')}
            </Typography>
            <div className={classes.distributorImageAndNameRow}>
              <OrangeUnderline className="OrangeUnderline">
                <h1 className={classes.companyName}>{distributorName}</h1>
              </OrangeUnderline>
            </div>
          </div>
        </Grid>
        <Grid item container xs={12} className={classes.bodyContainer}>
          {/* 1st column */}
          <Grid item xs={12} sm={6} className={clsx(classes.contentColumn, classes.firstColumn)}>
            {(street1 || street1no || street2 || street2no || zip || city) && (
              <ContentGroup>
                <ContentLabel className="Contentlabel">
                  {t('distributorManager_distributorInfo_streetAddress')}
                </ContentLabel>
                <ContentLineGroup className="ContentLineGroup">
                  {(street1 || street1no) && (
                    <ContentLine className="contentLine">{`${street1} ${street1no}`}</ContentLine>
                  )}
                  {(street2 || street2no) && (
                    <ContentLine className="contentLine">{`${street2} ${street2no}`}</ContentLine>
                  )}
                  {(zip || city) && <ContentLine>{`${zip} ${city}`}</ContentLine>}
                </ContentLineGroup>
              </ContentGroup>
            )}

            {phone && (
              <ContentGroup>
                <ContentLabel className="Contentlabel">{t('personManager_personInfo_phone')}</ContentLabel>
                <ContentLineGroup className="ContentLineGroup">
                  <ContentLine className="contentLine">{phone}</ContentLine>
                </ContentLineGroup>
              </ContentGroup>
            )}

            {email && (
              <ContentGroup>
                <ContentLabel className="Contentlabel">{t('personManager_personInfo_email')}</ContentLabel>
                <ContentLineGroup className="ContentLineGroup">
                  <ContentLine className="contentLine">
                    <EmailWrap email={email} />
                  </ContentLine>
                </ContentLineGroup>
              </ContentGroup>
            )}
          </Grid>
          {/* 2nd column */}
          <Grid item xs={12} sm={6} className={clsx(classes.contentColumn, classes.secondColumn)}>
            {(contactPersonName || contactPersonPhone || contactPersonEmail) && (
              <ContentGroup>
                <ContentLabel className="Contentlabel">{t('address.contactPerson')}</ContentLabel>
                <ContentLineGroup className="ContentLineGroup">
                  {contactPersonName && <ContentLine className="contentLine">{contactPersonName}</ContentLine>}
                  {contactPersonPhone && <ContentLine className="contentLine">{contactPersonPhone}</ContentLine>}
                  {contactPersonEmail && (
                    <ContentLine className="contentLine">
                      <EmailWrap email={contactPersonEmail} />
                    </ContentLine>
                  )}
                </ContentLineGroup>
              </ContentGroup>
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    distributorInfo: state.distributors.distributorInfo,
  };
};

export default compose(withTranslation(), withStyles(styles), connect(mapStateToProps, null))(DistributorInfos);
